import { Button } from "@/ui/Button";
import { Screen } from "@/ui/Screen";
import { Body, Display, Label, Tiny } from "@/ui/Text";

interface ConsentProps {
  readonly onAgree: () => void;
}

/**
 * What happens to what a person says. Vendors are deliberately not named here
 * (the privacy policy lists them), but nothing on this screen may be untrue:
 * answers are written by third-party AI services, and every message passes
 * the deterministic safety check in backend/src/app/safety.py first.
 */
const CONSENT_PARAGRAPHS: readonly string[] = [
  "Antar's answers are written by AI. When you ask something, your question and your chart go securely through our servers to the AI services we use, which write the answer.",
  "When you talk out loud, your voice is turned into text and her answer is turned back into speech by specialist voice services.",
  "Every message goes through Antar's own safety check before anything else happens.",
  "The AI doesn't work out your chart. Your planets, houses and dasha periods come from an astronomical calculation, and the AI only explains them.",
  "We never sell your data, and on the web we never ask for your contacts. The companies we work with are listed in our privacy policy.",
];

export function Consent({ onAgree }: ConsentProps) {
  return (
    <Screen middle foot={<Button label="Agree and continue" onClick={onAgree} />}>
      <Label>How Antar works</Label>
      <Display className="mt-2">One thing before you start.</Display>
      <div className="mt-5 space-y-3">
        {CONSENT_PARAGRAPHS.map((paragraph) => (
          <Body key={paragraph}>{paragraph}</Body>
        ))}
      </div>
      <Tiny className="mt-5">By continuing, you agree to this.</Tiny>
    </Screen>
  );
}
